import {ClientEvent} from '@udemy/event-tracking';

/**
 This event is fired when a user clicks on any links/hooks/etc that interfaces
 with a 3rd party vendor that funnels data downstream
 */
export class UFBFormActionClickEvent extends ClientEvent {
    componentName: string;
    placement: string;
    userType: string;
    utmSource: string;
    constructor({
        componentName,
        placement,
        userType,
        utmSource,
    }: {
        componentName: string;
        placement: string;
        userType: string;
        utmSource: string;
    }) {
        super('UFBFormActionClickEvent');
        this.componentName = componentName;
        this.placement = placement;
        this.userType = userType;
        this.utmSource = utmSource;
    }
}
